<template>
  <div>
    <RowCard
      :theme="theme"
      class="align-start py-4"
      style="position: relative; min-height: 100px"
    >
      <div :style="{ width: headers[0].width }" class="flex-center gap-4">
        <v-btn small icon @click="onEdit(item.id)">
          <Iconify icon="material-symbols:edit" size="15px"></Iconify>
        </v-btn>
        <v-btn small icon @click="onPreview(item.id)">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
      </div>
      <div
        :style="{ width: headers[1].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.no }}
      </div>
      <div
        :style="{ width: headers[2].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        {{ item.fiscal_year }}
      </div>
      <div
        :style="{ width: headers[3].width }"
        :class="{ 'theme-color-seven': redText }"
      >
        <div
          class="one-line mb-5"
          :class="[redText ? 'theme-color-seven' : 'black--text']"
          style="height: 20px"
        >
          <tooltip-text :text="item?.name" />
        </div>
        <div
          v-if="item.start_date && item.end_date"
          class="one-line font-type-normal"
        >
          <tooltip-text
            :text="
              'ระยะเวลาเปิดรับโครงการ :' +
              toDateRangeFormat(item?.start_date, item?.end_date)
            "
            :className="isNowInRange(item.start_date, item.end_date) ? '' : 'theme-color-seven'"
          />
        </div>
      </div>
      <div
        :style="{
          width: headers[4].width,
          color: statusColorSeparator(item.status),
        }"
      >
        {{ returnStatus(item.status) }}
      </div>

      <!--      <v-btn-->
      <!--        absolute-->
      <!--        top-->
      <!--        right-->
      <!--        icon-->
      <!--        :class="{ rotate180: isExpanded }"-->
      <!--        @click="seeDetail"-->
      <!--      >-->
      <!--        <Iconify-->
      <!--          icon="material-symbols:keyboard-arrow-down"-->
      <!--          color="#D3D3D3"-->
      <!--        ></Iconify>-->
      <!--      </v-btn>-->
    </RowCard>

    <!--    <div class="expand-layout px-5" :class="[rand]">-->
    <!--      <div class="expand-content">-->
    <!--        <div class="d-flex justify-space-between" style="gap: 12px">-->
    <!--          <div></div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat } from "../plugins/global-funcs";

export default {
  name: "MainProjectItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
    };
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Draft":
          this.theme = 2;
          // this.redText = true;
          return "";

        case "Inactive":
          this.theme = 1;
          return "var(--theme-color-seven)";

        case "Active":
          this.theme = 3;
          return "var(--theme-color-three)";

        default:
          return "var(--theme-color-two)";
      }
    },
    returnStatus(status) {
      switch (status) {
        case "Draft":
          return "ฉบับร่าง";

        case "Inactive":
          return "ปิดรับโครงการ";

        case "Active":
          return "เปิดรับโครงการ";

        default:
          return "-";
      }
    },
    extendRequest() {
      this.$router.push(`/rsp/extend-time/${this.item.id}/form`);
    },
    onPreview(id) {
      this.$router.push({ path: `/main-project-form/${id}?preview=true` });
    },
    onEdit(id) {
      this.$router.push({ path: `/main-project-form/${id}` });
    },
    isNowInRange(startDate, endDate) {
        const now = new Date();
        const start = new Date(startDate);
        const end = new Date(endDate);
        return now >= start && now <= end;
    }
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>
